import { Section } from "@models/ISchema";
import { isSectionFullyPastBlocked } from "./isSectionFullyPastBlocked";

export interface SectionsByPastPartition {
  visibleSections: Section[];
  pastSections: Section[];
  /**
   * True when hiding the past sections would leave an empty listing. `SectionsList` uses it to
   * force the section-level switch on and disabled, so consumers that need to know whether those
   * sections are actually on screen must read this instead of the raw `showPast` flag.
   */
  onlyPastSections: boolean;
}

/**
 * Splits the sections of a link into the ones always shown and the ones the section-level
 * "show past sections" switch governs. A section only counts as past when every one of its
 * assigned sessions is blocked by the threshold and it has no unassigned sessions.
 */
export const partitionSectionsByPast = (
  sections: Section[],
  thresholdDate: string | null,
  canEditPastSessions: boolean,
): SectionsByPastPartition => {
  const visibleSections: Section[] = [];
  const pastSections: Section[] = [];

  sections.forEach(section => {
    if (isSectionFullyPastBlocked(section, thresholdDate, canEditPastSessions)) {
      pastSections.push(section);
    } else {
      visibleSections.push(section);
    }
  });

  return {
    visibleSections,
    pastSections,
    onlyPastSections: pastSections.length > 0 && visibleSections.length === 0,
  };
};
